import React from 'react';
import Header from './components/Header';
import ContactSection from './components/Contact';

import AppRoutes from './routes';


function App() {
  return (
    <div>
      <Header />
     <AppRoutes/>
      <ContactSection />
      
    </div>
  );
}

export default App;
